import AcquisitionsAPI from "@/api/acquisitions";
import { SelectBox } from "@monolith-forensics/monolith-ui";
import { useQuery } from "@tanstack/react-query";
import { FC } from "react";

interface AcquisitionTypeSelectorProps {
  defaultValue?: string;
  onChange?: (value: string) => void;
  error?: string;
  openOnFocus?: boolean;
}

type AcquisitionType = {
  type: string;
  type_id: number;
};

const AcquisitionTypeSelector: FC<AcquisitionTypeSelectorProps> = ({
  defaultValue,
  onChange,
  error,
  openOnFocus = false,
}) => {
  const { data: typeList } = useQuery<AcquisitionType[]>({
    queryKey: ["acquisition:types:list"],
    queryFn: () => AcquisitionsAPI.getTypes(),
  });

  const options =
    typeList?.map((type) => ({
      label: type?.type,
      value: type?.type,
    })) || [];

  return (
    <>
      <SelectBox
        defaultValue={defaultValue}
        size="sm"
        variant="outlined"
        label="Type"
        placeholder="Select..."
        description="The type of acquisition method used."
        onChange={onChange}
        data={options}
        error={error}
        clearable={true}
        searchable={true}
        allowCustomValue={true}
        openOnFocus={openOnFocus}
      />
    </>
  );
};

export default AcquisitionTypeSelector;
